import { IonContent } from '@ionic/react';
import React from 'react';

import {
  GIRLS_CATEGORY,
  S3_BUCKET_URL,
  STRAIGHT_MAN_CATEGORY,
  WOMEN_CATEGORY,
} from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI/components/Title';
import { useLayoutFormSelections } from '../../../OwnAISecond/hooks/useLayoutFormSelections';

import { ScreenAboutLookStyles } from './AboutLook.styles';

export const ScreenAboutLookFemale: React.FC = () => {
  const { age } = useLayoutFormSelections();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    const categoriesToPin = age === '50_plus' ? WOMEN_CATEGORY : GIRLS_CATEGORY;
    const categories = [categoriesToPin, STRAIGHT_MAN_CATEGORY];

    userService.createOrUpdate({
      categories,
      onboarding_data: {
        first_categories: categories,
      },
    });
    wizard.nextStep();
  };

  const getBgImage = () => {
    return `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`;
  };

  return (
    <ScreenAboutLookStyles bgImage={<img src={getBgImage()} alt="Chat Vibe" />}>
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You've nailed the appearance—seriously, great choice! Now, let's dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
